
import { DataService } from '../utilities/data.service';

export class ConsentsToggleService {

    /**
     * category.showDetail = showDetail
     * @param category
     * @param showDetail
     */
    static changeCategoryShowDetailStatus(category, isShowDetail) {
        category.showDetail = isShowDetail;
    }

    /**
     * consent.showDetail = showDetail
     * @param consentToggleFields
     * @param showDetail
     */
    static changeConsentShowDetailStatus(consentToggleFields, isShowDetail) {
        consentToggleFields.showDetail = isShowDetail;
        if (isShowDetail) {
            consentToggleFields.showHistory = false;
            consentToggleFields.showSubConsents = false;
        }
    }

    /**
     * consent.showSubConsents = showSubConsents
     * @param consentToggleFields
     * @param showSubConsents
     */
    static changeConsentShowSubConsentStatus(consentToggleFields, isShowSubConsents) {
        consentToggleFields.showSubConsents = isShowSubConsents;
        if (isShowSubConsents) {
            consentToggleFields.showHistory = false;
            consentToggleFields.showDetail = false;
        }
    }

    /**
     * consent.showHistory = showHistory
     * @param consentToggleFields
     * @param showHistory
     */
    static changeConsentShowHistoryStatus(consentToggleFields, isShowHistory) {
        consentToggleFields.showHistory = isShowHistory;
        if (isShowHistory) {
            consentToggleFields.showDetail = false;
            consentToggleFields.showSubConsents = false;
        }
    }

    /**
     * set all consents, category show state to false
     */
    static resetConsentActiveStatus() {
        DataService.categories.forEach(category => {
            ConsentsToggleService.changeCategoryShowDetailStatus(category, false);
        });
        DataService.consents.forEach(consent => {
            ConsentsToggleService.changeConsentShowDetailStatus(consent, false);
            ConsentsToggleService.changeConsentShowHistoryStatus(consent, false);
            ConsentsToggleService.changeConsentShowSubConsentStatus(consent, false);
        });
    }
}
